// extracted by mini-css-extract-plugin
module.exports = {"accountNavigationName":"account-navigation_19fu2","container":"account-navigation_1H07d","onBackground":"account-navigation_3DQnJ","onWhite":"account-navigation_190qA"};